import React from "react";
import cx from "classnames";
import {
  Row, Col, Accordion
} from "react-bootstrap";
import isEqual from "is-equal";

import _ from "lodash";
import styles from "./CustomFieldView.module.scss";

import { localizedStrings } from 'src/localization';
import Button from "src/components/button";
import Text from "src/components/text";

class CustomFieldView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: true,
      showAll: false,
      value: this.props.value
    };

    this._handleToggleField = this._handleToggleField.bind(this);
    this._handleOptionClick = this._handleOptionClick.bind(this);
    this._handleViewMoreClicked = this._handleViewMoreClicked.bind(this);

    this.localizedCommons = localizedStrings.commons

  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.value, nextProps.value)) {
      this.setState({
        value: nextProps.value
      });
    }
  }

  _handleToggleField() {
    this.setState({
      expanded: !this.state.expanded
    })
  }

  _handleOptionClick(option, index) {
    if (this.props.onChange) {
      this.props.onChange({
        id: this.props.field.id,
        index: this.props.fieldIndex,
        value: {
          ...option,
          index: index
        }
      })
    }
  }

  _handleViewMoreClicked() {
    this.setState({
      showAll: true
    })
  }

  render() {

    return (
        <Accordion defaultActiveKey="0" onSelect={this._handleToggleField}>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <div className={styles.categoryNameWrapper} >
              <Text lines={1} className={styles.categoryName}  text={this.props.field.name} />
              <i className={cx('paperflite-dropdown',{
                [styles.collapsed] : !this.state.expanded,
                [styles.expanded] : this.state.expanded
              })}/>
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <Row>
                {this._renderOptions(this.props.field)}
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion> 
    );
  }

  _renderOptions(field) {
    if (!field.options || field.options.length == 0) {
      return false;
    }
    var optionsToShow = 6;
    var shouldCollapse = field.options.length > optionsToShow && !this.state.showAll;

    var options = field.options;

    if (shouldCollapse) {
      options = field.options.slice(0, optionsToShow);
    }

    let itemNodes = options.map((option, index) => {
      var selected = (this.state.value || []).find(item => {
        return item.id == option.id;
      });

      return (
        <Col key={option.id} md={12}
          className={styles.option}
          onClick={this._handleOptionClick.bind(this, option, index)}>
          <i
            className={cx(styles.selection, { [styles.active]: selected }, {
              "fa-solid fa-circle-check": selected,
              "paperflite-radio-button-unselected": !selected
            })}
          />
          <span className={styles.name}>
            <Text text={option.value} tooltip={{ placement: "auto" }}/>
          </span>
        </Col>
      );
    });
    if (shouldCollapse) {
      itemNodes.push(
        <Col key="view_more" lg={12} xl={12} md={12} className={styles.viewMore}>
            <Button className={styles.viewMoreButton} icon={'paperflite-add'} text='View More' onClick={this._handleViewMoreClicked} />
         </Col>
      );
    }

    return itemNodes;
  }

}

export default CustomFieldView;